import {SelectOption} from "@/components/select/Select.types.ts";
import {NOTIFICATION_EVENT_LABELS, NotificationEvent} from "@/lib/types/maintenance.ts";

export const EVENT_OPTIONS: SelectOption[] = Object.values(NotificationEvent).map((event) => ({
  label: NOTIFICATION_EVENT_LABELS[event],
  value: event,
}));

export enum TimingUnit {
  MINUTES_BEFORE = "MINUTES_BEFORE",
  HOURS_BEFORE = "HOURS_BEFORE",
  DAYS_BEFORE = "DAYS_BEFORE",
  MINUTES_AFTER = "MINUTES_AFTER",
  HOURS_AFTER = "HOURS_AFTER",
  DAYS_AFTER = "DAYS_AFTER",
}

export const TIMING_UNIT_OPTIONS: SelectOption<TimingUnit>[] = [
  {label: "minutes before", value: TimingUnit.MINUTES_BEFORE},
  {label: "hours before", value: TimingUnit.HOURS_BEFORE},
  {label: "days before", value: TimingUnit.DAYS_BEFORE},
  {label: "minutes after", value: TimingUnit.MINUTES_AFTER},
  {label: "hours after", value: TimingUnit.HOURS_AFTER},
  {label: "days after", value: TimingUnit.DAYS_AFTER},
];
